import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, IconButton, DialogContent } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import LeadService from '../../../core/services/leadsService';
import toast from 'react-hot-toast';
import { format } from 'date-fns';
// Set up localization for react-big-calendar with moment.js
const localizer = momentLocalizer(moment);

const AgentSchedulingModal = ({ open, onClose, agentId }) => {
    const [getSlot, setGetSlot] = useState([]);
    
    

    // Initial fetch for current date
    

    const eventStyleGetter = (event) => {

        let backgroundColor = '';
        if (event?.title === 'Home valuation') backgroundColor = '#d61c1c';
        if (event?.title === 'Schedule a tour') backgroundColor = '#37599b';

        const style = {
            backgroundColor,
            borderRadius: '8px',
            opacity: 0.8,
            color: 'white',
            border: '0px',
            display: 'block',
            cursor: 'pointer',
            marginBottom: '2px'

        };
        return {
            style: style
        };
    }
    return (
        <Dialog
            open={open}
            fullWidth
            maxWidth="lg"
            sx={{
                '& .MuiDialog-paper': {
                    borderRadius: '22px',
                },
            }}
        >
            <DialogTitle>
                Scheduling
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                

            </DialogContent>
        </Dialog>
    );
};

export default AgentSchedulingModal;
